import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router';
import { getSubjectContent } from '../../services/learnService';
import { PUBLIC_KEY } from '../../utils/EditorToolbar';
import { updateOrder, saveOrders } from '../../services/paymentService';
import { notification, Collapse, Modal } from 'antd';
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router';
import moment from 'moment';
import Place from '../../assets/icons/Place';
import picture from '../../assets/images/instructor.svg';
import {
  Link as ScrollLink,
  animateScroll as scroll,
  Element,
} from 'react-scroll';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useFlutterwave } from 'flutterwave-react-v3';
import Money from '../../assets/icons/Money';
import { baseURL } from '../../utils/axios';
import ReactPixel from 'react-facebook-pixel';
import toast from 'react-hot-toast';
import { scrollToTop } from '../../utils/utils';

const SingleCourse = () => {
  useEffect(() => {
    ReactPixel.pageView(); // Track a page view event
  }, []);

  let sCart = JSON.parse(localStorage.getItem('cart'));
  let values = JSON.parse(localStorage.getItem('userData'));
  let token = localStorage.getItem('token');

  const [content, setContent] = useState([]);
  const [school, setSchool] = useState({});
  const [buyFreeLoading, setBuyFreeLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('about');
  const [cart, setCart] = useState(sCart || []);
  const [showPreview, setShowPreview] = useState(false);
  const [reference, setReference] = useState('');

  useEffect(() => {
    setReference(`PL-EDV${Date.now()}${Math.floor(Math.random() * 10 + 1)}`);
  }, []);

  const navigate = useNavigate();
  let str = useParams();
  let courseId = str?.id?.split('-').pop();
  let title = str?.id?.split('-')[0];

  let query = new URLSearchParams(useLocation().search);
  let schoolId = query.get('school');

  useEffect(() => {
    scrollToTop();
    const getContent = async () => {
      try {
        let res = await getSubjectContent(schoolId, courseId);
        setContent(res.data.course);
      } catch (error) {
        console.log(error);
      }
    };

    getContent();
  }, []);

  useEffect(() => {
    const getSchool = async () => {
      try {
        const res = await fetch(`${baseURL}/schools/${schoolId}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer `,
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        const data = await res.json();

        if (res.status === 200) {
          setSchool(data.data.school);
        }
        if (res.status === 401) {
          notification['error']({
            message: 'Session expired, please log in again',
          });
          navigate('/login');
        }
      } catch (error) {
        console.log(error);
      }
    };

    getSchool();
  }, []);

  const handleCancel = () => {
    setShowPreview(false);
  };

  const config = {
    public_key: PUBLIC_KEY,
    tx_ref: reference,
    amount: content?.price,
    currency: 'NGN',
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: values?.email || '',
      phone_number: '',
      name: `${values?.firstName} ${values?.lastName}` || '',
    },
    customizations: {
      title: 'Personalized Learning by Edves',
      description: 'Payment for items in cart',
      logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  const pay = async () => {
    if (!values) {
      notification['error']({
        message: 'Please log in first',
      });

      return;
    }
    if (values?.school) {
      notification['error']({
        message: 'This is a tutor account, please log in as a student',
      });

      return;
    }

    let orderData = {
      courses: [content.id],
      paymentGateway: 1,
      reference: reference,
    };
    let response = await saveOrders(values.id, orderData, token);

    handleFlutterPayment({
      callback: async (response) => {
        let token = localStorage.getItem('token');

        let verifyResponse = await updateOrder(
          values.id,
          {
            paymentGatewayReference: response.transaction_id,
          },
          token,
          response.tx_ref
        );
      },
      onClose: () => {
        navigate(`/view-subject/${title}-${courseId}?school=${schoolId}`);
        localStorage.removeItem('cart');
      },
    });
  };

  const buyFreeCourse = async () => {
    setBuyFreeLoading(true);
    let orderData = {
      courses: [content.id],
      paymentGateway: 1,
      reference: reference,
    };

    try {
      let response = await saveOrders(values.id, orderData, token);

      let verifyResponse = await updateOrder(
        values.id,
        {
          paymentGatewayReference: 'free',
        },
        token,
        response.data.order.reference
      );

      notification['success']({
        message: 'You have enrolled successfully',
      });
      navigate(`/view-subject/${title}-${courseId}?school=${schoolId}`);
      setBuyFreeLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error(
          'Your session is either expired or you are logged in as a tutor. \n Please log in again as a student'
        );
      } else {
        console.log(error);
        setBuyFreeLoading(false);
        notification['error']({
          message: 'An error occurred',
        });
      }
    } finally {
      setBuyFreeLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className='subject-content-wrapper'>
        <div>
          <div
            className='single-subject__hero'
            style={{
              background: `linear-gradient( 
            rgba(54, 54, 165, 0.7) 100%, 
            rgba(54, 54, 165, 0.7)100%),url(${
              content?.subject_class?.title?.toLowerCase()?.includes('biology')
                ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833246/4_ywa1uq.jpg'
                : content?.subject_class?.title
                    ?.toLowerCase()
                    ?.includes('mathematics')
                ? 'https://leverageedu.com/blog/wp-content/uploads/2020/07/Branches-of-Mathematics.png'
                : content?.subject_class?.title
                    ?.toLowerCase()
                    ?.includes('english')
                ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrP9mK3dTuXB86woJ2JW7J8TkxszYhRVk_4Q&usqp=CAU'
                : content?.subject_class?.title?.toLowerCase().includes('food')
                ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680783147/food_and_nutrition_lqxah9.png'
                : content?.subject_class?.title
                    ?.toLowerCase()
                    .includes('economics')
                ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833433/9_eknlh0.jpg'
                : content?.subject_class?.title
                    ?.toLowerCase()
                    .includes('technical')
                ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833564/3_tzp8za.jpg'
                : ''
            }) `,
            }}
            //style={{ backgroundImage: `url(${headerImg})` }}
          >
            <div className='single-subject__hero__breadcrumbs'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                  fill='white'
                />
              </svg>
              <p>
                {' '}
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate('/dashboard')}
                >
                  Home
                </span>{' '}
                | {content?.subject_class?.title}
              </p>
            </div>
            <h3>{content?.subject_class?.title}</h3>
            <p style={{ marginTop: '18px', color: '#fff', fontSize: '24px' }}>
              Offered by: {school?.name}
            </p>
          </div>

          <div className='learn-tabs'>
            <ScrollLink to='about'>
              <p
                className={
                  activeTab === 'about'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('about')}
              >
                About This Subject
              </p>
            </ScrollLink>
            <ScrollLink to='features'>
              <p
                className={
                  activeTab === 'features'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('features')}
              >
                What you'll learn
              </p>
            </ScrollLink>
            <ScrollLink to='topics'>
              <p
                className={
                  activeTab === 'topics'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('topics')}
              >
                Subject Topics
              </p>
            </ScrollLink>
            <ScrollLink to='features'>
              <p
                className={
                  activeTab === 'schedules'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('schedules')}
              >
                Live Class Schedule
              </p>
            </ScrollLink>
            <ScrollLink to='instructor'>
              <p
                className={
                  activeTab === 'instructor'
                    ? `learn-tabs__link active-learn-tab`
                    : `learn-tabs__link`
                }
                onClick={() => setActiveTab('instructor')}
              >
                Instructor
              </p>
            </ScrollLink>
          </div>
          <div className='learn-flex'>
            <div className='learn-about'>
              <h3>About this subject</h3>
              <div className='learn-about__teaser'>
                {content?.teaser && (
                  <div onClick={() => setShowPreview(true)}>
                    <video src={content.teaser} playsInline controls='true' />
                  </div>
                )}
                {/* <img src={teaser} alt=''  */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <p>
                    {content?.description ||
                      'No description available for this course'}
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      className='play-icon-wrapper'
                      onClick={() => setShowPreview(true)}
                    >
                      <svg
                        width='11'
                        height='14'
                        viewBox='0 0 11 14'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M2 3.64L7.27 7L2 10.36V3.64ZM0 0V14L11 7L0 0Z'
                          fill='#323232'
                        />
                      </svg>
                    </div>
                    <p>Watch introductory video about this subject</p>
                  </div>
                </div>
              </div>
            </div>

            <div className='content-details'>
              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <Money />
                </div>
                <div className='content-details__item__text'>
                  <h3>Amount</h3>
                  {Number(content?.price) === 0 ? (
                    <h3 style={{ color: '#4CAF92', fontsize: '24px' }}>Free</h3>
                  ) : (
                    <h3 style={{ color: '#4CAF92', fontsize: '24px' }}>
                      {content?.currency?.symbol}
                      {Number(content?.price)
                        ? Number(content?.price)?.toLocaleString()
                        : 0.0}
                      {/* {new Intl.NumberFormat('en-NG', {
                      style: 'currency',
                      currency: 'NGN',
                    }).format(content?.price || 0)} */}
                    </h3>
                  )}
                </div>
              </div>

              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='34'
                    height='34'
                    viewBox='0 0 34 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM16.9997 30.3335C9.63301 30.3335 3.66634 24.3668 3.66634 17.0002C3.66634 9.6335 9.63301 3.66683 16.9997 3.66683C24.3663 3.66683 30.333 9.6335 30.333 17.0002C30.333 24.3668 24.3663 30.3335 16.9997 30.3335ZM17.833 8.66683H15.333V18.6668L24.083 23.9168L25.333 21.8668L17.833 17.4168V8.66683Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Duration</h3>
                  <p>Estimated {content?.duration} to complete</p>
                </div>
              </div>

              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='40'
                    height='41'
                    viewBox='0 0 40 41'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clipPath='url(#clip0_1750_8431)'>
                      <path
                        d='M31.6667 8.53752V32.4423H8.33333V8.53752H31.6667ZM31.6667 5.12256H8.33333C6.5 5.12256 5 6.65929 5 8.53752V32.4423C5 34.3205 6.5 35.8572 8.33333 35.8572H31.6667C33.5 35.8572 35 34.3205 35 32.4423V8.53752C35 6.65929 33.5 5.12256 31.6667 5.12256Z'
                        fill='#5A5955'
                      />
                      <path
                        d='M23.3337 29.027H11.667V25.612H23.3337V29.027ZM28.3337 22.197H11.667V18.7821H28.3337V22.197ZM28.3337 15.3671H11.667V11.9521H28.3337V15.3671Z'
                        fill='#5A5955'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_1750_8431'>
                        <rect width='40' height='40.9796' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Lessons</h3>
                  <p>{content?.topics_count} Lessons</p>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '25px',
                }}
              >
                {Number(content?.price) !== 0 && (
                  <Button
                    text={'Add to cart'}
                    className='primary-btn'
                    width='100%'
                    onClick={() => {
                      if (sCart?.some((item) => item.id === content.id)) {
                        notification['error']({
                          message: 'Item already exists in cart',
                        });
                      } else {
                        notification['success']({
                          message: 'Item added to cart',
                        });
                        setCart([...cart, content]);
                        localStorage.setItem(
                          'cart',
                          JSON.stringify([...cart, { ...content, school }])
                        );
                      }
                    }}
                  />
                )}
                {Number(content?.price) === 0 ? (
                  <Button
                    text={buyFreeLoading ? 'Please wait...' : 'Enrol Now'}
                    className='primary-btn'
                    width='100%'
                    disabled={buyFreeLoading}
                    onClick={() =>
                      token ? buyFreeCourse() : navigate('/login')
                    }
                  />
                ) : (
                  <Button
                    text='Enrol Now'
                    className='orange-border'
                    width='100%'
                    onClick={() =>
                      token ? pay() : navigate('/login?cart=true')
                    }
                  />
                )}
              </div>
            </div>
          </div>
          <Element name='features' smooth='true'>
            <div className='learn-about'>
              <h3>What you'll learn</h3>
              <div className='learn-about__what-you-will-learn'>
                {content?.learning_outcomes?.map((el) => (
                  <div
                    className='learn-about__flex-item'
                    key={Math.random(1000)}
                  >
                    <div className='learn-about__flex-item__circle'>
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z'
                          fill='#161410'
                        />
                      </svg>
                    </div>
                    <p>{el.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </Element>

          <Element name='topics' smooth='true'>
            <div className='learn-about'>
              <h3>Topics in {content?.subject_class?.title}</h3>
              <p>{content?.topics?.length || 0} topic(s) available</p>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                {content?.topics?.map((el) => (
                  <div className='topic-card'>
                    <img src={content.banner} alt='' />
                    <div className='topic-card__body'>
                      <h4>{el?.title}</h4>
                      <p>{el.description}</p>

                      <div className='topic-card__count '>
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <g clip-path='url(#clip0_4398_26197)'>
                            <path
                              d='M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2Z'
                              fill='#5A5955'
                            />
                            <path
                              d='M9.33366 11.3346H4.66699V10.0013H9.33366V11.3346ZM11.3337 8.66797H4.66699V7.33464H11.3337V8.66797ZM11.3337 6.0013H4.66699V4.66797H11.3337V6.0013Z'
                              fill='#5A5955'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_4398_26197'>
                              <rect width='16' height='16' fill='white' />
                            </clipPath>
                          </defs>
                        </svg>
                        <p>{el.lessons_count} Lessons</p>
                        <p>{el.activity_count} Activities</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Element>

          <Element name='topics' smooth='true'>
            <div className='learn-about'>
              <h3>Group live class schedule</h3>
              <p>
                The schedule for the live class are added automatically to your
                live class page
              </p>

              <div className='learn-about__schedule'>
                <div className='learn-about__schedule__icon'>
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clipPath='url(#clip0_4556_18787)'>
                      <path
                        d='M10 5.33333V10.6667H3.33333V5.33333H10ZM10.6667 4H2.66667C2.3 4 2 4.3 2 4.66667V11.3333C2 11.7 2.3 12 2.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9L14 11.6667V4.33333L11.3333 7V4.66667C11.3333 4.3 11.0333 4 10.6667 4Z'
                        fill='#5A5955'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_4556_18787'>
                        <rect width='16' height='16' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div>
                  {content?.live_classes?.map((el) => (
                    <div className='learn-about__schedule__texts'>
                      <h4>
                        {moment(el?.start_date).format('lll')} -{' '}
                        {moment(el?.end_date).format('lll')}
                      </h4>
                      {el?.schedules?.map((item) => (
                        <div className='learn-about__schedule__texts__item'>
                          <p> Every {item?.day}</p>
                          <svg
                            width='4'
                            height='4'
                            viewBox='0 0 4 4'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <circle cx='2' cy='2' r='2' fill='#D5D4D4' />
                          </svg>
                          <p>
                            {item.start_time} - {item.end_time}
                          </p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Element>
          <div className='mobile-content'>
            <div className='content-details__item'>
              <div className='content-details__item__icon-wrapper'>
                <Money />
              </div>
              <div className='content-details__item__text'>
                <h3>Amount</h3>
                {Number(content?.price) === 0 ? (
                  <h3 style={{ color: '#4CAF92', fontsize: '24px' }}>Free</h3>
                ) : (
                  <h3 style={{ color: '#4CAF92', fontsize: '24px' }}>
                    {content?.currency?.symbol}
                    {Number(content?.price)?.toLocaleString()}
                    {/* {new Intl.NumberFormat('en-NG', {
                      style: 'currency',
                      currency: 'NGN',
                    }).format(content?.price || 0)} */}
                  </h3>
                )}
              </div>
            </div>

            <div className='content-details__item'>
              <div className='content-details__item__icon-wrapper'>
                <svg
                  width='34'
                  height='34'
                  viewBox='0 0 34 34'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM16.9997 30.3335C9.63301 30.3335 3.66634 24.3668 3.66634 17.0002C3.66634 9.6335 9.63301 3.66683 16.9997 3.66683C24.3663 3.66683 30.333 9.6335 30.333 17.0002C30.333 24.3668 24.3663 30.3335 16.9997 30.3335ZM17.833 8.66683H15.333V18.6668L24.083 23.9168L25.333 21.8668L17.833 17.4168V8.66683Z'
                    fill='#5A5955'
                  />
                </svg>
              </div>
              <div className='content-details__item__text'>
                <h3>Duration</h3>
                <p>Estimated {content?.duration} to complete</p>
              </div>
            </div>

            <div className='content-details__item'>
              <div className='content-details__item__icon-wrapper'>
                <svg
                  width='40'
                  height='41'
                  viewBox='0 0 40 41'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g clipPath='url(#clip0_1750_8431)'>
                    <path
                      d='M31.6667 8.53752V32.4423H8.33333V8.53752H31.6667ZM31.6667 5.12256H8.33333C6.5 5.12256 5 6.65929 5 8.53752V32.4423C5 34.3205 6.5 35.8572 8.33333 35.8572H31.6667C33.5 35.8572 35 34.3205 35 32.4423V8.53752C35 6.65929 33.5 5.12256 31.6667 5.12256Z'
                      fill='#5A5955'
                    />
                    <path
                      d='M23.3337 29.027H11.667V25.612H23.3337V29.027ZM28.3337 22.197H11.667V18.7821H28.3337V22.197ZM28.3337 15.3671H11.667V11.9521H28.3337V15.3671Z'
                      fill='#5A5955'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_1750_8431'>
                      <rect width='40' height='40.9796' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className='content-details__item__text'>
                <h3>Lessons</h3>
                <p>{content?.topics_count} Lessons</p>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '25px',
              }}
            >
              {Number(content?.price) !== 0 && (
                <Button
                  text={'Add to cart'}
                  className='primary-btn'
                  width='100%'
                  onClick={() => {
                    if (sCart?.some((item) => item.id === content.id)) {
                      notification['error']({
                        message: 'Item already exists in cart',
                      });
                    } else {
                      notification['success']({
                        message: 'Item added to cart',
                      });
                      setCart([...cart, content]);
                      localStorage.setItem(
                        'cart',
                        JSON.stringify([...cart, { ...content, school }])
                      );
                    }
                  }}
                />
              )}
              {Number(content?.price) === 0 ? (
                <Button
                  text={buyFreeLoading ? 'Please wait...' : 'Enrol Now'}
                  className='primary-btn'
                  width='100%'
                  disabled={buyFreeLoading}
                  onClick={() => (token ? buyFreeCourse() : navigate('/login'))}
                />
              ) : (
                <Button
                  text='Enrol Now'
                  className='orange-border'
                  width='100%'
                  onClick={() => (token ? pay() : navigate('/login?cart=true'))}
                />
              )}
            </div>
          </div>

          <Element name='instructor' smooth='true'>
            <div className='learn-about instructor'>
              <h3>Instructor</h3>
              <div className='instructor__details'>
                <div className='instructor__details__image'>
                  <img src={school.logo || picture} alt={school.name} />
                </div>
                <div className='instructor__details__info'>
                  <h4>{school.name}</h4>
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center',
                      marginBottom: '16px',
                    }}
                  >
                    <Place />
                    {school?.state ? (
                      <p style={{ margin: '0' }}>
                        {`${school?.state},${
                          school?.country ? school?.country : 'Nigeria'
                        }`}
                      </p>
                    ) : (
                      <p style={{ margin: '0' }}>Lagos,Nigeria</p>
                    )}
                  </div>
                  <p style={{ marginBottom: '8px' }}>{school?.bio}</p>

                  <p
                    className='learn-about__more'
                    onClick={() => navigate(`/schools/${school?.id}`)}
                  >
                    Read More On School Profile
                    <svg
                      width='16'
                      height='16'
                      viewBox='0 0 16 16'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M6.66656 4L5.72656 4.94L8.7799 8L5.72656 11.06L6.66656 12L10.6666 8L6.66656 4Z'
                        fill='#FEA82F'
                      />
                    </svg>
                  </p>
                </div>
              </div>
            </div>
          </Element>
        </div>
      </div>
      <div className='texture-bg'>
        <div className='cta'>
          <div className='cta__left'>
            <h1>
              Your academic subject weakness can become an area of strength
            </h1>
            <p>
              Be the first to know when we go live, register on PL by Edves and{' '}
              <br /> become academic stars
            </p>
          </div>
          <div className='cta__right'>
            <Button className='secondary-button' text='Be The First To Know' />
          </div>
        </div>
      </div>

      <Footer />
      <Modal
        width={606}
        visible={showPreview}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <p>Subject introductory preview</p>
          <h2>{content?.subject_class?.title}</h2>
          <div className='teaser-wrap'>
            <video controls>
              <source src={content?.teaser} type='video/mp4' />
              Your browser does not support HTML video.
            </video>
          </div>
          <Button
            text={`Enrol Now`}
            className='primary-btn'
            width='100%'
            onClick={() => (token ? pay() : navigate('/login?cart=true'))}
          />
        </div>
      </Modal>
    </>
  );
};

export default SingleCourse;
